export default "__VITE_ASSET__6437576d__"